/* eslint-disable no-script-url */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import LeftSidebar from './LeftSideBar';
import BurgerMenuSVG from '../icons/menuIcon.svg';
import { getOrganizationPropertiesByHost } from '../../../utils/helpers';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

export function TopMenu({ menuItems, viewType }) {
  if (!menuItems) return null;
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <ul className={`${viewType === 'sidebar' ? 'flex-col' : 'items-center md:gap-2.5'} flex`}>
      {
      menuItems && menuItems?.top_header?.length > 0 && menuItems.top_header.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index} className={`${viewType === 'sidebar' ? `border-b border-gray-200 ${openIdx === index ? 'pt-3' : 'py-3'} w-full` : ''}`}>
          <div className="relative text-left group">
            <button
              type="button"
              className={item.class}
              onClick={(e) => {
                if (viewType === 'sidebar' && item.sub_menu && item.sub_menu.length > 0) {
                  e.preventDefault();
                  setOpenIdx(openIdx === index ? null : index);
                }
              }}
            >
              {item.icon_display === 1 && (
              <span className="inline-block mr-2">
                <Image
                  src="https://cdnstatic.nextias.com/assets/images/icons/blink-im.gif"
                  width={10}
                  height={10}
                  alt="blink-icon"
                />
              </span>
              )}
              <Link
                href={item.url && item.url !== '#' ? item.url : '#'}
                target={item.target ? '_blank' : undefined}
                rel={item.target ? 'noopener noreferrer' : undefined}
                onClick={(e) => {
                  if (item.url === '#') {
                    e.preventDefault();
                    window.location.reload();
                    return;
                  }
                  if (viewType === 'sidebar' && item.sub_menu && item.sub_menu.length > 0) {
                    e.preventDefault();
                    setOpenIdx(openIdx === index ? null : index);
                  } else if (item.url === '#' || item.url?.startsWith('#')) {
                    e.preventDefault();
                    window.location.href = item?.url;
                  }
                  if (item?.url && item?.url !== '#') {
                    window.location.href = item?.url; // RELOAD
                  }
                }}
              >
                {item.menu_name}
              </Link>
            </button>

            {item.menu_name === 'Anubhav-III Prelims' && (
              <Image
                src="https://cdnstatic.nextias.com/resources/images/icons/896364502151419600_image.gif"
                width={20}
                height={20}
                alt="highlight"
                className={`absolute ${viewType === 'sidebar' ? '-top-2 right-20' : '-top-2 right-1'} w-8 h-4 transform-gpu rotate-2`}
                style={{ filter: 'drop-shadow(0px 4px 7px rgba(0,0,0,0.4))', transform: 'translateZ(0)' }}
              />
            )}

            {item.sub_menu && item.sub_menu.length > 0 && (
              viewType === 'sidebar' ? (
                <div className={`${openIdx === index ? 'block' : 'hidden'} static w-full bg-white border border-gray-300 rounded-md mt-1`}>
                  <ul className="py-2 text-gray-700">
                    {item.sub_menu.map((subItem, subIndex) => (
                      <li key={subIndex} className="px-4 py-1 cursor-pointer">
                        <Link href={subItem.url === '#' ? 'javascript:void(0)' : subItem.url} className={`${subItem.class} whitespace-normal break-words`}>
                          {subItem.menu_name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="absolute z-50 left-0 hidden xl:w-[170px] w-full origin-top-left rounded-md bg-white border border-gray-300 group-hover:block">
                  <ul className="py-2 text-gray-700">
                    {item.sub_menu.map((subItem, subIndex) => (
                      <li key={subIndex} className="px-3 py-1 cursor-pointer">
                        <Link
                          href={subItem?.url && subItem.url !== '#' ? subItem.url : '#'}
                          className={subItem.class}
                          onClick={(e) => {
                            if (subItem?.url) {
                              e.preventDefault();
                              window.location.href = subItem?.url;
                            } else if (subItem?.url === '#') {
                              e.preventDefault();
                              window.location.reload();
                            }
                          }}
                        >
                          {subItem.menu_name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )
            )}
          </div>
        </li>
      ))
    }
    </ul>
  );
}

TopMenu.propTypes = {
  menuItems: PropTypes.object,
  viewType: PropTypes.string,
};

export default function HeaderTop({ topMenuItems }) {
  const [isOpen, setIsOpen] = useState(false);
  const { miscellaneousData } = useMiscellaneousData();
  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const isNextIas = currentOrg.organizationName === 'nextias';
  const router = useRouter();
  const isHindiCourseGroupPage = router.asPath === '/hindi' || router.asPath.startsWith('/hindi/');

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleLanguageClick = (lang) => {
    if (lang === 'en') {
      window.location.href = 'https://www.nextias.com';
    } else if (lang === 'hi') {
      window.location.href = 'https://www.nextias.com/hindi';
    }
  };

  const activeLangClass = 'border border-red-500 bg-red-500 hover:bg-red-700 text-white font-normal py-1 px-2 text-sm rounded-[5px]';
  const inactiveLangClass = 'border border-red-500 text-red-500 font-normal py-1 px-2 text-sm rounded-[5px]';

  return (
    <>
      <div className={`flex container items-center justify-end px-2 ${isNextIas ? 'py-2 xl:px-[18px]' : 'py-2 xl:py-0'}`}>
        <div className="hidden xl:block">
          <TopMenu menuItems={topMenuItems} />
        </div>

        <button type="button" className="hidden xl:inline-block border border-transparent bg-transparent text-gray-6/25 font-normal py-1 px-2 text-sm ml-3">
          <Link href={isNextIas ? 'tel:8081300200' : 'tel:9021300500'} className="text-sm text-[#344767] flex items-center">
            <Image src="https://cdnstatic.nextias.com//call-icon-1756755577127.svg" width={14} height={14} alt="call-icon" className="mr-2" />
            {
              currentOrg?.organizationName === 'nextias' ? (
                <>
                  80813-00200
                </>
              ) : (
                <>
                  90213-00500
                </>

              )
            }
          </Link>
        </button>
        {
          currentOrg?.organizationName === 'nextias' && (
            <>
              <div className={`${isHindiCourseGroupPage ? inactiveLangClass : activeLangClass} ml-3`}>
                <button data-no-translate type="button" onClick={() => handleLanguageClick('en')}>EN</button>
              </div>
              <div className={`${isHindiCourseGroupPage ? activeLangClass : inactiveLangClass} ml-2`}>
                <button type="button" onClick={() => handleLanguageClick('hi')}>हिंदी</button>
              </div>
            </>
          )
        }
        <button
          type="button"
          className="xl:hidden flex items-center justify-center py-1 px-2 ml-3 rounded-md focus:outline-none border"
          onClick={toggleMenu}
        >
          <div className="space-y-1">
            <Image className="w-6 h-6 xl:w-[30px] lg-h-[30px]" width={30} height={30} src={BurgerMenuSVG} alt="hamburgerMenu" />
          </div>
        </button>
      </div>
      <LeftSidebar isOpen={isOpen} handleSetLeftSidebar={setIsOpen} items={topMenuItems} />
    </>
  );
}

HeaderTop.propTypes = {
  topMenuItems: PropTypes.object,
};
